import React, { useState, useEffect } from 'react'
import * as ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { TextField } from '@material-ui/core'
import DatePickerProvider from '../input/DatePickerProvider'
import MyDatePicker from '../input/MyDatePicker'
import { Autocomplete, createFilterOptions } from '@material-ui/lab'
import { contractTypePresentation, convertHarfCharacter } from '../../utility'
import MyReactInput from '../input/MyReactInput'
import MyReactSelect from '../input/MyReactSelect'
import moment from 'moment'
import 'moment/locale/ja'
moment.locale('ja')

export default function ItemsFilterInputs (props) {
  const conditions = props.conditions
  const [character, setCharacter] = useState(null)
  const [contractType, setContractType] = useState(null)

  const characters = props.characters.filter((character) => !character.is_default)
    .concat(
      props.characters.filter((character) => character.is_default)
        .map((character) => {
          character.title = 'その他'
          return character
        }))

  useEffect(() => {
    'character_id,contract_type,item_price_min'.split(',').forEach((name) => {
      if (conditions[name]) {
        conditions[name] = parseInt(conditions[name])
      } else {
        conditions[name] = ''
      }
    })
    'period_to_min,period_from_max,item_name'.split(',').forEach((name) => {
      if (!conditions[name]) {
        conditions[name] = ''
      }
    })

    if (conditions.character_id !== '') {
      setCharacter(props.characters.filter((char) => char.id === conditions.character_id)[0])
    }
    if (conditions.contract_type !== '') {
      setContractType(conditions.contract_type)
    }
  }, [])

  return (
    <div className="card text-body my-1">
      <div className="card-header bg-theme-success text-white p-1">
          アイテム検索
      </div>
      <div className="card-body p-1 text-left">
        <form className="bg-white" action={location.href} method="GET" id='condition-form'
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault()
            }
          }}
        >
          <Autocomplete
            id="select-character"
            value={character}
            options={characters}
            getOptionLabel={(option) => option ? option.title : ''}
            onChange={(e, value) => { setCharacter(value) }}
            renderInput={(params) => <TextField {...params} label="キャラクター名" className='w-100 mb-2' />}
            filterOptions={createFilterOptions({
              stringify: (option) => convertHarfCharacter(option.title) + convertHarfCharacter(option.title, true) // 全角/半角に変換したものを両方検索対象として検索しやすくする
            })}
            disabled={props.readonly}
          />
          <input type="text" className="d-none" name="character_id" value={character ? character.id : ''} readOnly />
          <Autocomplete
            id="select-contract-type"
            value={contractType}
            options={props.enableXr ? [3] : [1, 2]}
            getOptionLabel={(option) => contractTypePresentation(option)}
            onChange={(e, value) => { setContractType(value) }}
            renderInput={(params) => <TextField {...params} label="契約形態" className='w-100 mb-2' />}
            disabled={props.readonly}
          />
          <input type="text" className="d-none" name="contract_type" value={contractType || ''} readOnly />
          <DatePickerProvider>
            <div className="mb-2">
              <MyDatePicker
                id="period-to-min"
                name="period_to_min"
                label="契約期間（この日以降を含む）"
                value={conditions.period_to_min}
                readOnly={props.readonly}
              />
            </div>
            <div className="mb-2">
              <MyDatePicker
                id="period-from-max"
                name="period_from_max"
                class='mb-2'
                label="契約期間（この日以前を含む）"
                value={conditions.period_from_max}
                readOnly={props.readonly}
              />
            </div>
          </DatePickerProvider>
          <MyReactInput
            labelText="アイテム名"
            inputProps={{
              id: 'item-name',
              name: 'item_name',
              class: 'mb-2',
              type: 'text',
              value: conditions.item_name,
              readonly: props.readonly
            }}
          />
          <MyReactInput
            labelText="アイテム価格（下限）"
            inputProps={{
              id: 'item-price-min',
              name: 'item_price_min',
              class: 'mb-2',
              type: 'number',
              value: conditions.item_price_min,
              readonly: props.readonly,
              min: 0
            }}
          />
          <MyReactInput
            labelText="アイテム価格（上限）"
            inputProps={{
              id: 'item-price-max',
              name: 'item_price_max',
              class: 'mb-2',
              type: 'number',
              value: conditions.item_price_max,
              readonly: props.readonly,
              min: 0
            }}
          />
          {props.enableXr && (
            <MyReactInput
              labelText="申請ID"
              inputProps={{
                id: 'xr-contract-id',
                name: 'xr_contract_id',
                class: 'mb-2',
                type: 'string',
                value: conditions.xr_contract_id,
                readonly: props.readonly
              }}
            />
          )}
          <MyReactInput
            labelText="契約ID"
            inputProps={{
              id: 'contract-id',
              name: 'contract_id',
              class: 'mb-2',
              type: 'string',
              value: conditions.contract_id,
              readonly: props.readonly
            }}
          />
          <MyReactSelect
            labelText="ソート"
            selectProps={{
              id: 'order-by',
              name: 'order_by',
              class: 'mb-2',
              value: conditions.order_by ?? 'applied_at',
              readonly: props.readonly
            }}
            options={[
              { value: 'applied_at', text: '申請日' },
              { value: 'coop_con_id', text: '契約ID' },
              { value: 'character_id', text: 'キャラクターID' },
              { value: 'period_to', text: '契約終了日' },
              { value: 'name', text: 'アイテム名' }
            ]}
          />
          <MyReactSelect
            labelText="昇順/降順"
            selectProps={{
              id: 'order-direction',
              name: 'order_direction',
              class: 'mb-2',
              value: conditions.order_direction ?? 'desc',
              readonly: props.readonly
            }}
            options={[
              { value: 'asc', text: '昇順' },
              { value: 'desc', text: '降順' }
            ]}
          />
          {props.fixedConditionNames.map((name) => (
            <input key={name} type="text" className="d-none" name={name} value={conditions[name] ?? ''} readOnly />
          ))}
        </form>
        <form className="d-none" action={location.href} method="GET" id='condition-form-without-values'>
          {props.fixedConditionNames.map((name) => (
            <input key={name} type="text" className="d-none" name={name} value={conditions[name] ?? ''} readOnly />
          ))}
        </form>
        {!props.readonly && (
          <>
            <button type='submit' form='condition-form-without-values' className="btn ol-theme-success float-left">クリア</button>
            <button type='submit' form='condition-form' className="btn bg-theme-success float-right">検索</button>
          </>
        )}
      </div>
    </div>
  )
}

ItemsFilterInputs.propTypes = {
  characters: PropTypes.arrayOf(PropTypes.object),
  conditions: PropTypes.object,
  fixedConditionNames: PropTypes.arrayOf(PropTypes.string),
  readonly: PropTypes.bool,
  enableXr: PropTypes.bool
}

ItemsFilterInputs.defaultProps = {
  fixedConditionNames: [],
  readonly: false,
  enableXr: false
}

$('#items-filter-inputs').each((i, el) => {
  const qel = $(el)
  const props = qel.data() // bladeでdata-xxxx形式で指定した値がpropsとして参照できる
  ReactDOM.render(<ItemsFilterInputs {...props}/>, el)

  Object.keys(props).map((key) => { // ソースにdata-属性が残らないように削除
    qel.removeAttr('data-' + key.replace(/[A-Z]/g, (s) => '-' + s.charAt(0).toLowerCase()))
    return 0
  })
})
